import { _ } from "src/services";

export const PackageBoxShimmer: React.FC = () => (
    <div className="package-box d-flex flex-column shimming">
        <div className="header d-flex align-items-center">
            <div className="shimmer logo" />
            <span className="w-100 shimmer"></span>
        </div>
        <ul className="description">
            {[...new Array(4)].map((x, i) => <li key={i}><span className="w-100 shimmer"></span></li>)}
        </ul>
        <span className="btn btn-submit disabled">{_("selectAndContinue")}</span>
    </div>
);